import * as actionTypes from "./actionTypes";
import axios from "../../axios-amps";
import { logFirebaseEvent } from "../../shared/utility";
import { serverconfigs } from "../../constants";

export const fetchQualityScoreCategoriesStarted = () => {
  return {
    type: actionTypes.FETCH_QUALITY_SCORE_CATEGORIES_STARTED,
  };
};

export const fetchQualityScoreCategoriesSuccess = (qualityScoreCategories) => {
  return {
    type: actionTypes.FETCH_QUALITY_SCORE_CATEGORIES_SUCCESS,
    qualityScoreCategories: qualityScoreCategories,
  };
};

export const fetchQualityScoreCategoriesFailed = () => {
  return {
    type: actionTypes.FETCH_QUALITY_SCORE_CATEGORIES_FAILED,
  };
};

export const fetchQualityScoreCategories = (providerId: string) => {
  return (dispatch) => {
    dispatch(fetchQualityScoreCategoriesStarted());
    axios
      .get(serverconfigs.fetchQualityScoreCategoriesUrl+`/${providerId}/categories`)
      .then((response) => {
        console.log(response.data);
        dispatch(fetchQualityScoreCategoriesSuccess(response.data.result));
      })
      .catch((error) => {
        if (error.statusCode === 400) {
          logFirebaseEvent("Exception400");
        } else if (error.statusCode === 401) {
          logFirebaseEvent("Exception401");
        } else if (error.statusCode === 500) {
          logFirebaseEvent("Exception500");
        }
        dispatch(fetchQualityScoreCategoriesFailed());
      });
  };
};

export const resetFetchQualityScoreCategories = () => {
  return {
    type: actionTypes.RESET_FETCH_QUALITY_SCORE_CATEGORIES,
  };
};
